import React from 'react';
import classnames from 'classnames';
import useLogin from '../../../hooks/use-login';
import { ELoginType } from '../../../enum';
import styled from './index._less';


export default () => {

  const { changeLoginType, loginType } = useLogin();

  return (
    <>
      <div className="login-switch-bar">
        {
          loginType === ELoginType.Qrcode
          ? <div className="login-switch-bar-scan">
            扫码登录
          </div>
          : <div className="login-switch-bar-line">
            <div
              className={ classnames({ 'active': loginType === ELoginType.Reg }) }
              onClick={ () => changeLoginType(ELoginType.Reg) }
            >登录/注册</div>
            <div
              className={ classnames({ 'active': loginType === ELoginType.Login }) }
              onClick={ () => changeLoginType(ELoginType.Login) }
            >密码登录</div>
          </div>
        }
      </div>
      <style jsx>{ styled }</style>
    </>
  )
}
